export const HEATING_SYSTEMS = [
  "BKT",
  "ceiling diffuser",
  "heater under window",
  "heater not under window",
  "none",
] as const;

export const COOLING_SYSTEMS = [...HEATING_SYSTEMS] as const;

export const T_AIR_SUPPLY_TYPES = ["from_file", "static"] as const;

export const VENTILATION_TYPES = ["mechanical", "natural"] as const;

export const ROOM_SYSTEM_OPTION_FIELDS = {
  coolingSystem: COOLING_SYSTEMS,
  heatingSystem: HEATING_SYSTEMS,
  ventilationType: VENTILATION_TYPES,
} as const;

export type RoomSystemOptionField = keyof typeof ROOM_SYSTEM_OPTION_FIELDS;

export const isRoomSystemOptionField = (key: string): key is RoomSystemOptionField => key in ROOM_SYSTEM_OPTION_FIELDS;
